import { getCalendarDaysAgo } from './HelperFunctions';

/**
 * Calendar-day age label: "today", "yesterday", or "N days ago".
 * Never uses hours/minutes — a job posted this morning always reads as today.
 *
 * @param {string|Date|number} date
 * @param {number} [nowMs=Date.now()]
 * @returns {string|null}
 */
export function calendarDaysAgoLabel(date, nowMs = Date.now()) {
  if (date == null || date === '') return null;
  const days = getCalendarDaysAgo(date, nowMs);
  if (days == null) return null;
  if (days === 0) return 'today';
  if (days === 1) return 'yesterday';
  return `${days} days ago`;
}

/**
 * "Posted today" / "Posted yesterday" / "Posted 3 days ago".
 *
 * @param {string|Date|number} date
 * @param {number} [nowMs=Date.now()]
 * @returns {string}
 */
export default function postedAgo(date, nowMs = Date.now()) {
  const label = calendarDaysAgoLabel(date, nowMs);
  return label ? `Posted ${label}` : '';
}
